// extracted by mini-css-extract-plugin
export default {"Name":"NameCell_Name__AnBs9","Cell":"NameCell_Cell__C78WU","Icon":"NameCell_Icon__XEcOp"};